module.exports = __webpack_public_path__ + "img/bg-pages.e4e138e1.jpg";